<template>
  <div
    class="map"
    :style="{ backgroundImage: mapImage }"
    @click="openMap"
  ></div>
</template>

<script>
import { ref, computed, watch } from "vue";
export default {
  props: {
    mapCenter: {
      type: Object,
      required: true,
      validator: value => {
        return value.lat && value.lng;
      }
    },
    mapUrl: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const STATIC_MAP_BASE_URL =
      "https://maps.googleapis.com/maps/api/staticmap?";
    const API_KEY = "AIzaSyCB5IZDRWvwHXfz6P6Zij1kaFLDspuKMQk";
    const query = ref(null);

    watch(props => {
      loadMap();
      return props;
    });

    loadMap();

    function loadMap() {
      //Place marker at center
      // Labels must be alphanumeric uppercase {A-Z, 0-9}
      const markersList = [
        {
          color: "red",
          lat: props.mapCenter.lat,
          lng: props.mapCenter.lng,
          label: ""
        }
      ];

      const markersString = formatMarkersList(markersList);
      const zoom = "12";
      const size = {
        hor: "200",
        ver: "230"
      };
      const mapType = "roadmap";

      const params = `&center=${props.mapCenter.lat},${props.mapCenter.lng}&zoom=${zoom}&size=${size.hor}x${size.ver}&maptype=${mapType}${markersString}&key=${API_KEY}`;
      query.value = `${STATIC_MAP_BASE_URL}${params}`;
    }

    const mapImage = computed(() => {
      return `url(${query.value})`;
    });

    function formatMarkersList(list) {
      let markersString = "";
      list.forEach(marker => {
        markersString += `&markers=color:${marker.color}%7Clabel:${marker.label}%7C${marker.lat},${marker.lng}`;
      });
      return markersString;
    }

    function openMap() {
      window.open(props.mapUrl, "_blank");
    }
    return { query, mapImage, openMap };
  }
};
</script>

<style scoped>
.map {
  height: 100%;
  width: 100%;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
